// extracted by mini-css-extract-plugin
module.exports = {"log":"logsList__log"};